// Zod без JIT-пробы — тишина в отчётах CSP.
//
// Zod 4 один раз проверяет доступность eval вызовом `new Function("")` и,
// поймав исключение, работает дальше по медленному пути. Под строгим CSP
// (`script-src` без `unsafe-eval`) браузер всё равно фиксирует нарушение
// политики: у каждого пользователя в DevTools висел красный Issue «Content
// Security Policy of your site blocks the use of 'eval' in JavaScript»
// (жалоба 2026-08-19).
//
// Флаг `jitless` — штатная ручка самого Zod ровно для этого случая: он
// пропускает пробу. Ничего не теряем — JIT под нашим CSP недоступен в любом
// случае, проба всегда возвращала false.
//
// Только фронт: на сервере CSP нет, eval доступен, и JIT там полезен.

import { config } from "zod";

config({ jitless: true });
